import { useState, useEffect } from "react";
import "./Templates.css";
import { useCoreDataLoader } from "../../hooks/useCoreDataLoader";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { 
    selectForms,
    selectFormThemes,
    selectTags,
    selectUIStates,
    selectUser,
    setUIStates} from "../../redux/features/appData";
import toast from "react-hot-toast";
import { toastFail, toastSuccess } from "../../config";
import { useDispatch } from "react-redux";
import { FormThemeExtended, iconPath } from "effno-core";
import { ICONS } from "../shared/media";
import { FormTheme } from "../question-design/FormTheme";
import { LayoutTemplate } from "lucide-react";

export default function Tags() {
    const storeUser = useSelector(selectUser);
    const storeForms = useSelector(selectForms)
    const storeTags = useSelector(selectTags);
    const uiStates = useSelector(selectUIStates);
    const formThemes = useSelector(selectFormThemes);
    
    const { reloadAll }  = useCoreDataLoader();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [selectedTagId, setSelectedTagId] = useState<string | undefined>(undefined);
    const [deleteTagModalIsOpen, setDeleteTagModalIsOpen] = useState<boolean>(false);
    const [renameTagModalIsOpen, setRenameTagModalIsOpen] = useState<boolean>(false);
    const [newTagModalIsOpen, setNewTagModalIsOpen] = useState<boolean>(false);
    const [tagFormCounts, setTagFormCounts] = useState<{[key: string]: number} | undefined>(undefined);

    useEffect(() => {
        if (!uiStates) {
            return;
        }

        dispatch(setUIStates({
            ...uiStates,
            viewingResponses: false,
            viewingShare: false
        }));
        
    }, [])


    return (
        <div id="templates">
            <div className="templates-header">
                <div className="page-title">
                    Templates
                </div>

                <div className="templates-header-actions">
                    <div 
                        className="templates-header-action"
                        style={{display: "none"}}
                    >
                        <LayoutTemplate size={16} />

                          {/* <img src={iconPath(ICONS.TEMPLATES, storeUser)} /> */}
                        New Template
                    </div>
                </div>
            </div>

            <div className="templates-list">
                
                <div 
                    className="coming-soon"
                    style={{fontWeight: "400", fontSize: "1.5rem", marginTop: "24px"}}
                >
                    {/* Coming Soon */}
                </div>
            </div>

        </div>
        
    )
}